import React from 'react';
import { Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * Created-success modal (self-contained overlay).
 * Reused for agents, tools, and teams.
 */
const AgentSuccessModal = ({
  title = 'Agent Created!',
  desc = 'Congratulations, your agent is active successfully, you can start using it.',
  noBtn,
  continueLabel = 'Continue to agents',
  continuePath = '/agents',
  onClose,
}) => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => onClose?.()}>
      <div
        className="bg-shell-card border border-shell-card-border rounded-xl p-8 w-full max-w-md text-center"
        onClick={e => e.stopPropagation()}>
        <div className="w-14 h-14 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center mx-auto mb-4">
          <Check className="w-7 h-7 text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-ink mb-2 font-serif">{title}</h3>
        <p className="text-sm text-muted leading-relaxed max-w-xs mx-auto">{desc}</p>
        {!noBtn && (
          <button
            type="button"
            onClick={() => navigate(continuePath)}
            className="mt-6 w-full px-4 py-2.5 text-sm font-medium bg-primary hover:bg-primary/90 text-white rounded-lg transition-colors">
            {continueLabel}
          </button>
        )}
        {noBtn && (
          <button
            type="button"
            onClick={() => onClose?.()}
            className="mt-6 w-full px-4 py-2.5 text-sm font-medium bg-primary hover:bg-primary/90 text-white rounded-lg transition-colors">
            Close
          </button>
        )}
      </div>
    </div>
  );
};

export default AgentSuccessModal;
